import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import Select from 'antd/lib/select';
import mobileApi from '../api';

const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 9 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 15 },
    sm: { span: 14 },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: { span: 14, offset: 6 },
    sm: { span: 14, offset: 6 },
  },
};

@translate()
@Form.create()
export default class PinChange extends Component {
  state = {
    devices: [],
    loadingDevices: false,
    smsSent: false,
    sendingSms: false,
    submitting: false,
    formVisible: false,
    selectedDeviceId: null,
  };

  componentDidMount() {
    this.fetchDevices();
  }

  fetchDevices = async () => {
    this.setState({ loadingDevices: true });
    const response = await mobileApi.fetchDevices();
    if (response.ok) {
      const devices = response.data || [];
      this.setState({
        devices,
        selectedDeviceId: devices.length > 0 ? devices[0].id : null,
      });
    }
    this.setState({ loadingDevices: false });
  };

  handleShowForm = () => {
    this.setState({ formVisible: true, smsSent: false });
    this.props.form.resetFields();
  };

  handleCancel = () => {
    this.setState({ formVisible: false, smsSent: false });
    this.props.form.resetFields();
  };

  handleSendSms = async () => {
    const { t } = this.props;
    const { selectedDeviceId } = this.state;

    if (!selectedDeviceId) {
      message.warning(t('Vyberte zariadenie'));
      return;
    }

    this.setState({ sendingSms: true });
    const response = await mobileApi.sendPinSms(selectedDeviceId);
    if (response.ok) {
      message.success(t('SMS kód bol odoslaný'));
      this.setState({ smsSent: true });
    }
    this.setState({ sendingSms: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { form, t } = this.props;
    const { selectedDeviceId } = this.state;

    form.validateFields(async (err, values) => {
      if (err) return;

      this.setState({ submitting: true });
      const response = await mobileApi.changePin({
        device_id: selectedDeviceId,
        current_pin: values.current_pin,
        new_pin: values.new_pin,
        sms_code: values.sms_code,
      });

      if (response.ok) {
        message.success(t('PIN bol úspešne zmenený'));
        this.setState({ formVisible: false, smsSent: false });
        form.resetFields();
      }
      this.setState({ submitting: false });
    });
  };

  render() {
    const { t, form } = this.props;
    const {
      devices,
      loadingDevices,
      smsSent,
      sendingSms,
      submitting,
      formVisible,
      selectedDeviceId,
    } = this.state;
    const { getFieldDecorator } = form;

    return (
      <div style={{ marginTop: 24 }}>
        <h3>{t('Zmena PIN-u')}</h3>

        {!formVisible && (
          <Button
            type="primary"
            size="small"
            onClick={this.handleShowForm}
            disabled={loadingDevices || devices.length === 0}
          >
            {t('Zmeniť PIN')}
          </Button>
        )}

        {formVisible && (
          <Spin spinning={submitting}>
            <Form onSubmit={this.handleSubmit}>
              {devices.length > 1 && (
                <Form.Item {...formItemLayout} label={t('Zariadenie')}>
                  <Select
                    value={selectedDeviceId}
                    onChange={(val) => this.setState({ selectedDeviceId: val, smsSent: false })}
                    style={{ width: '100%' }}
                  >
                    {devices.map((d) => (
                      <Option key={d.id} value={d.id}>
                        {d.device_name || d.id}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}

              <Form.Item {...formItemLayout} label={t('Aktuálny PIN')}>
                {getFieldDecorator('current_pin', {
                  rules: [{ required: true, message: t('Zadajte aktuálny PIN') }],
                })(
                  <Input type="password" placeholder={t('Aktuálny PIN')} maxLength={8} />
                )}
              </Form.Item>

              <Form.Item {...formItemLayout} label={t('Nový PIN')}>
                {getFieldDecorator('new_pin', {
                  rules: [{ required: true, message: t('Zadajte nový PIN') }],
                })(
                  <Input type="password" placeholder={t('Nový PIN')} maxLength={8} />
                )}
              </Form.Item>

              <Form.Item {...tailFormItemLayout}>
                <Button
                  onClick={this.handleSendSms}
                  loading={sendingSms}
                  disabled={smsSent}
                  size="small"
                >
                  {smsSent ? t('SMS odoslaná') : t('Odoslať SMS kód')}
                </Button>
              </Form.Item>

              {smsSent && (
                <Form.Item {...formItemLayout} label={t('SMS kód')}>
                  {getFieldDecorator('sms_code', {
                    rules: [{ required: true, message: t('Zadajte SMS kód') }],
                  })(
                    <Input placeholder={t('SMS kód')} maxLength={10} />
                  )}
                </Form.Item>
              )}

              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="small"
                  disabled={!smsSent}
                  style={{ marginRight: 8 }}
                >
                  {t('Odoslať')}
                </Button>
                <Button size="small" onClick={this.handleCancel}>
                  {t('Zrušiť')}
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-settings/components/PinChange.js